import Label from "components/Common/Label/Label";
import SearchFilterDropdown from "components/Common/SearchableDropdown/SearchFilterDropdown";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { removeAgencyType, setAgencyType, setMultipleAgencyType } from "store/slices/searcSlice";
import { RootState } from "store/store";
import AgencySelect from "./AgencySelect";
import { resetAgencyType } from "store/slices/searcSlice";

interface AgencyTypesSelectProps {
  agencyListData: any; // Adjust the type based on the structure of agencyListData
  parentIndustryChangeTrigger: number | null;
  agencyTypeChangeTrigger: number | null;
  handelAgencyTypeChange: () => void; // A function that handles agency type change
}

const AgencyTypesSelect: React.FC<AgencyTypesSelectProps> = ({
  agencyListData,
  parentIndustryChangeTrigger,
  agencyTypeChangeTrigger,
  handelAgencyTypeChange
}: any) => {
  const agencyParent = useSelector((state: RootState) => state.search.agency_parents);
  const agencyTypes = useSelector((state: RootState) => state.search.agency_types);

  const [agencyOptions, setAgencyOptions] = useState<any>([]);
  const dispatch = useDispatch();


 
  // Handle individual selection
  const handleSelect = (value: any) => {
    handelAgencyTypeChange();
    if (value.includes("Select All")) {
      const agencyNames = agencyOptions
        .filter((option: any) => option.value !== "Select All" && option.value !== "Deselect All")
        .map((option: any) => option.value);
      dispatch(setMultipleAgencyType(agencyNames));
    } else if (value.includes("Deselect All")) {
      // Deselect all logic
      dispatch(resetAgencyType());
    } else {
      // Handle individual agency type selection
      const lastValue = value[value.length - 1];
      dispatch(setAgencyType(lastValue));
    }
  };

  const handleDeselect = (value: any) => {
    dispatch(removeAgencyType(value));
    handelAgencyTypeChange();
  };

  useEffect(() => {
    // dispatch(resetAgencyType());
    const result = agencyListData
      .filter((item: any) => agencyParent.includes(item.name))
      .map((item: any) => item.agencies)
      .flat();

    const uniqueAgencyTypes = Array.from(
      new Map(
        result
          .filter((item: any) => item.agency_type) // Apply your custom filter (e.g., remove empty values)
          .map((item: any) => [
            item.agency_type,
            { label: item.agency_type, value: item.agency_type },
          ])
      ).values()
    ).sort((a: any, b: any) => a.label.localeCompare(b.label));
    setAgencyOptions([
      { label: "Select All", value: "Select All" },
      { label: "Deselect All", value: "Deselect All" },
      ...uniqueAgencyTypes,
    ]);
  }, [agencyParent]);

  useEffect(() => {

    if (parentIndustryChangeTrigger !== null) {
      dispatch(resetAgencyType());
      handelAgencyTypeChange && handelAgencyTypeChange();
    }
  }, [parentIndustryChangeTrigger]);


  return (
    <>
      <div className="w-full mb-5">
        <Label
          labelTitle="Select Agencies type"
          isHelpIconRequired
          tooltipText={"This is a tooltip"}
        />
        <div className="mt-1.5 SelectProject-input">
          <SearchFilterDropdown
            mode="multiple"
            options={agencyOptions}
            onChange={handleSelect}
            defaultValue={agencyTypes}
            handleDeselect={handleDeselect}
            placeholder="Select agencies type"
          />
        </div>
      </div>
      <AgencySelect
        agencyListData={agencyListData}
        agencyTypeChangeTrigger={agencyTypeChangeTrigger}
      />
    </>
  );
};

export default AgencyTypesSelect;
